import React, { useRef } from 'react'
import Title from '../Shared/Title/Title'
import { RichText } from '../Shared/RichText/RichText'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './recipeCard.module.scss'
import { Swiper, SwiperSlide } from "swiper/react"
import { useLocalPath } from '../hooks/useLocalPath'
import { Pagination, Autoplay, Mousewheel, Keyboard } from "swiper"

const RecipeCard = ({ gridItems }) => {
    const { recipes, title, backgroundColor } = gridItems
    // const swiperRef = useRef()
    const option = {
        // spaceBetween: 20,
        loop: recipes.length > 2 ? true : false,
        centeredSlides: false,
        grabCursor: true,
        keyboard: {
            enabled: true
        },
        pagination: {
            dynamicBullets: true,
            clickable: true,
        },
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
                // navigation: false,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1.5,
                spaceBetween: 10,
            },
            // when window width is >= 640px
            767: {
                slidesPerView: recipes.length > 2 ? 3 : recipes.length > 1 ? 2 : 1,
                spaceBetween: 20
            },
            992: {
                slidesPerView: recipes.length > 2 ? 3 : recipes.length > 1 ? 2 : 1,
                spaceBetween: 30
            }
        },
        modules: [Pagination],
        // slidesPerView: recipes.length > 2 ? 3 : recipes.length > 1 ? 2 : 1,
    }

    return (
        <div className='container' style={{ background: backgroundColor }}>
            <div className={`container-lg ${styles.wrapper}`}>
                <h2 className={styles.title}><Title title={title} /> </h2>
                <div className={styles.cardContainer} >
                    <Swiper
                        // ref={swiperRef}
                        {...option}
                        draggable={true}
                    >
                        {
                            recipes && recipes.map((card: any, id: number) => {
                                const { slug, thumbnailImage, thumbnailTitle, recipeType } = card
                                return (
                                    <SwiperSlide className={styles.cardWrapper} key={id}>
                                        <Link to={useLocalPath(slug)} >
                                            <div className={styles.card}>
                                                <div className={styles.cardImage}>
                                                    <GatsbyImage
                                                        image={thumbnailImage.gatsbyImageData}
                                                        alt={`${thumbnailImage.title} img`}
                                                        loading="lazy"
                                                    />
                                                </div>
                                                <div className={styles.cardInfo}>
                                                    <p className={styles.type}>{recipeType}</p>
                                                    <div className={styles.cardTitle}> {thumbnailTitle} </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>
                </div>
            </div>
        </div>
    )
}

export default RecipeCard